import {useEffect, useState} from 'react'
import SharedData from '../../common/SharedData'
import {getUnseenStockRequestsCount} from './_requests'

export const STOCK_REQUESTS_SEEN_EVENT = 'stock-requests:seen'

export const notifyStockRequestsSeen = () => {
  window.dispatchEvent(new Event(STOCK_REQUESTS_SEEN_EVENT))
}

export const useUnseenStockRequests = (enabled: boolean): number => {
  const {currentUser, language} = SharedData()
  const token = currentUser?.token
  const [count, setCount] = useState(0)

  useEffect(() => {
    if (!enabled || !token) return
    let active = true
    getUnseenStockRequestsCount(token, language)
      .then((res) => {
        const n = Number(res.data?.data?.count ?? 0)
        if (active) setCount(Number.isFinite(n) && n > 0 ? n : 0)
      })
      .catch(() => {})
    return () => {
      active = false
    }
  }, [enabled, token, language])

  useEffect(() => {
    const clear = () => setCount(0)
    window.addEventListener(STOCK_REQUESTS_SEEN_EVENT, clear)
    return () => window.removeEventListener(STOCK_REQUESTS_SEEN_EVENT, clear)
  }, [])

  return count
}
